<template>
  <img
    :loading="lazy ? 'lazy' : 'eager'"
    :alt="photoCaptionAltFormatter(pitchTypePrimaryPhoto.caption)"
    :src="`/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${pitchTypePrimaryPhoto.url.masterImage}`"
    :srcset="`
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${pitchTypePrimaryPhoto.url.masterImage} 264w,
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=70,w=360,h=270${pitchTypePrimaryPhoto.url.masterImage} 360w
          `"
    :sizes="$isDesktop ? '264px' : '160px'"
    :width="$isDesktop ? '264' : '160'"
    :height="$isDesktop ? '198' : '120'"
    class="pt-primary"
    :class="{ desktop: $isDesktop }"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PitchTypePhoto } from '../../../../campsite-details/types'
import { photoCaptionAltFormatter } from '~/utility/photoCaptionAltFormatter'

@Component
class PitchTypeImage extends Vue {
  @Prop({ default: true })
  lazy: boolean

  @Prop({ required: true })
  pitchTypePrimaryPhoto: PitchTypePhoto[]

  photoCaptionAltFormatter(caption) {
    return photoCaptionAltFormatter(caption)
  }
}

export default toNative(PitchTypeImage)
</script>

<style scoped>
.pt-primary {
  border-radius: 0.3em;
  display: block;
  flex-shrink: 0;
  height: auto;
  margin: 0;
  width: 8em;
}

/* desktop & tablet */
.pt-primary.desktop {
  width: 264px;
}
</style>
